import { v4 as uuid } from 'uuid';
import { reactive } from 'vue';

export const ERROR = 'error';
export const WARNING = 'warning';
export const SUCCESS = 'success';

type NotificationType = 'error' | 'warning' | 'success' | 'notice';

const defaultTimeout: number = 8000;

const store = reactive({
  notifications: [] as {
    id: string;
    title: string;
    message: string | null;
    type: NotificationType | null;
    timeout?: number;
  }[],
  notify(
    title: string,
    message: string | null = null,
    type: NotificationType | null = null,
    timeout: number = defaultTimeout,
  ) {
    const id = uuid();
    let timer: ReturnType<typeof setTimeout> | null = null;

    if (timeout) {
      timer = setTimeout(() => this.dismiss(id), timeout);
    }

    this.notifications.push({
      id,
      title,
      message,
      type,
      timeout: timer as unknown as number,
    });

    return id;
  },
  dismiss(id: string) {
    const index = this.notifications.findIndex((notification) => notification.id === id);

    clearTimeout(this.notifications[index]?.timeout);
    this.notifications.splice(index, 1);
  },
  /**
   * Drop every notification on show, along with the timers waiting to dismiss them.
   *
   * Named to match the `$reset` every Pinia store has, though this one is a plain reactive
   * singleton rather than a store, so it isn't in Pinia's registry and `resetStores` cannot
   * reach it - `logout` calls this itself.
   */
  $reset() {
    for (const { timeout } of this.notifications) {
      clearTimeout(timeout);
    }

    this.notifications.splice(0);
  },
});

export default store;
